import React from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  // faEdit,
  faTrash,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";

const PaymentActionButton = ({
  id,
  item,
  setPaymentId,
  toggleShowUndo,
  downloadLetter,
  toggleShowAddEditPayment,
  setEdit,
  setEditItem,
  toggleShowDelete,
}) => {
  return (
    <span className="flex items-center gap-2 justify-center">
      {item?.is_reversed === 1 ? (
        <>Reversed</>
      ) : item?.is_refund === 1 ? (
        <>
          {item?.aba_file?.aba_file && (
            <>
              <CustomTooltip message={"Download ABA File"}>
                <span>
                  <FontAwesomeIcon
                    icon={faDownload}
                    size="1x"
                    onClick={() => {
                      !item?.is_reversed &&
                        downloadLetter(item?.aba_file?.aba_file);
                    }}
                    className={`${
                      item?.is_reversed ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
            </>
          )}
          Refunded
        </>
      ) : item?.deleted_at ? (
        <>Deleted</>
      ) : (
        <>
          {item?.aba_file?.aba_file ? (
            <>
              <CustomTooltip message={"Download ABA File"}>
                <span>
                  <FontAwesomeIcon
                    icon={faDownload}
                    size="1x"
                    onClick={() => {
                      !item?.is_reversed &&
                        downloadLetter(item?.aba_file?.aba_file);
                    }}
                    className={`${
                      item?.is_reversed ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  />
                </span>
              </CustomTooltip>
              {!item?.aba_file?.aba_file &&
                item?.is_reconciled === 0 &&
                !item?.deleted_at && (
                  <>
                    {/* <span>/</span>
                    <CustomTooltip message={"Edit"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faEdit}
                          size="1x"
                          onClick={() => {
                            setEdit(true);
                            setEditItem(item);
                            toggleShowAddEditPayment();
                            setPaymentId(id);
                          }}
                        />
                      </span>
                    </CustomTooltip> */}

                    <span>/</span>
                    <CustomTooltip message={"Delete"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faTrash}
                          size="1x"
                          onClick={() => {
                            setPaymentId(id);
                            toggleShowDelete();
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  </>
                )}
            </>
          ) : (
            <>
              {!item?.aba_file?.aba_file &&
                item?.is_reconciled === 0 &&
                !item?.deleted_at && (
                  <>
                    {/* <CustomTooltip message={"Edit"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faEdit}
                          size="1x"
                          onClick={() => {
                            setEdit(true);
                            setEditItem(item);
                            toggleShowAddEditPayment();
                            setPaymentId(id);
                          }}
                        />
                      </span>
                    </CustomTooltip> */}
                    {/* <span>/</span> */}
                    <CustomTooltip message={"Delete"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faTrash}
                          size="1x"
                          onClick={() => {
                            setPaymentId(id);
                            toggleShowDelete();
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  </>
                )}
            </>
          )}
          {item?.is_reversed === 0 && item?.is_reconciled === 0 && (
            <>
              <span>/</span>
              <CustomTooltip message={"Undo"}>
                <span>
                  <FontAwesomeIcon
                    icon={faUndo}
                    size="1x"
                    onClick={() => {
                      toggleShowUndo();
                      setPaymentId(id);
                    }}
                  />
                </span>
              </CustomTooltip>
            </>
          )}
        </>
      )}
    </span>
  );
};

export default PaymentActionButton;
